import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ProjectManagerDispatchOrderList from "./list";
import { Details } from "./details";

const ProjectManagerDispatchOrder = () => {
  const Location = useLocation();
  return (
    <>
      <Routes>
        <Route
          path={`/`}
          element={<Navigate replace="/" to={`${Location.pathname}/list`} />}
        ></Route>
        <Route path={"list"} element={<ProjectManagerDispatchOrderList />}></Route>
        <Route path={"detail/:id"} element={<Details />} />
      </Routes>
    </>
  );
};

export default ProjectManagerDispatchOrder;
